// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BranchListItem_branch-list-item__vwZmk {
  border-radius: 0.8rem;
  background-color: var(--gray-extra-light);
}

.BranchListItem_branch-list-item--checked__LrgEp {
  border: 1px solid var(--primary-color);
}

.BranchListItem_branch-list-item__label__kodf9 {
  cursor: pointer;
  padding: 2rem;
  display: flex;
  align-items: center;
  gap: 2rem;
}

.BranchListItem_branch-list-item__label-text__MUfNN {
  color: #000;
  font-size: var(--text-base);
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/Modals/BranchSelectionModal/BranchList/BranchListItem/BranchListItem.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB","sourcesContent":[".branch-list-item {\n  border-radius: 0.8rem;\n  background-color: var(--gray-extra-light);\n}\n\n.branch-list-item--checked {\n  border: 1px solid var(--primary-color);\n}\n\n.branch-list-item__label {\n  cursor: pointer;\n  padding: 2rem;\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.branch-list-item__label-text {\n  color: #000;\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"branch-list-item": `BranchListItem_branch-list-item__vwZmk`,
	"branch-list-item--checked": `BranchListItem_branch-list-item--checked__LrgEp`,
	"branch-list-item__label": `BranchListItem_branch-list-item__label__kodf9`,
	"branch-list-item__label-text": `BranchListItem_branch-list-item__label-text__MUfNN`
};
export default ___CSS_LOADER_EXPORT___;
